import React, {Component} from "react";
import { useStyles } from './styles';
import {Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, withStyles} from "@material-ui/core";
import {ruRU,enUS } from '@material-ui/core/locale';
import { createTheme, ThemeProvider } from '@material-ui/core/styles';
import apiStore from "../../store/ApiStore";
import moment from "moment";
import InputBase from "@material-ui/core/InputBase/InputBase";
import {Trans, Translation} from "react-i18next";
import InputAdornment from '@mui/material/InputAdornment';

import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import CurrencyDollarsIcon from '@mui/icons-material/AttachMoney';
import CurrencyEuroIcon from '@mui/icons-material/Euro';
import DoneOutlineIcon from '@mui/icons-material/DoneOutline';
import MenuItem from "@material-ui/core/MenuItem";
import userStore from "../../store/UserStore";



const theme = createTheme(
	{
		palette: {
			primary: { main: '#fff' },
		},
		root: {

		},

		cell: {
			border:0
		}
	},
	ruRU,
);

const BootstrapInput = withStyles((theme) => ({
	root: {
		'label + &': {
			marginTop: theme.spacing(3),
		},
	},
	input: {
		borderRadius: 4,
		position: 'relative',
		backgroundColor: theme.palette.background.paper,
		border: '1px solid #ced4da',
		fontSize: 16,
		padding: '10px 26px 10px 12px',
		transition: theme.transitions.create(['border-color', 'box-shadow']),
		// Use the system font instead of the default Roboto font.
		fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		].join(','),
		'&:focus': {
			borderRadius: 4,
			borderColor: '#80bdff',
			boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
		},
	},
}))(InputBase);


let timerIdCheckPayment: number = null;
// set time interval checking of payment, each 5 seconds (5000 ms)
const timeInterval = 5000;
// set time to stop the execution after 240 minuts of checking paymnet
const timeOut = (240 * 60000);

setTimeout(() => {
    if(timerIdCheckPayment) {
        clearInterval(timerIdCheckPayment);
        timerIdCheckPayment = null;
    }
	window.localStorage.removeItem("orderCost");
	window.localStorage.removeItem("orderCurrency");
	window.localStorage.removeItem("orderStatus");

	window.localStorage.removeItem("QR_DATA");
	window.localStorage.removeItem("QR_ID");
	window.localStorage.removeItem("QR_PSB_ID");
	window.localStorage.removeItem("QR_PSB_URL");
	window.localStorage.removeItem("QR_IMG_REF");

    console.log('Time interval is stopped by period.');
}, timeOut); // Executes once after 5 seconds

/*
function checkPayment() {
    console.log("checkPayment2...");
} */

class TopUpBalance extends Component {

	state = {
		errorRegistr: [],
		loading: false,
		rowsPerPageOptions: [10, 20, 50, 100],
		arUsers: [],
        productName: "Speaker-ID",
        manager: null,
		orderCost: 1000,
		orderCurrency: "RUBLE",
        orderStatus: "PURCHASE",// start purchase order
        imageURL_QR_ID: null,
		QR_ID: null,
        error: {
			isErrorDisplayed: false,
			errorMessage: ''
		},
		toDateDefault: moment(new Date()).format("YYYY-MM-DD") , //"2024-05-21"
		fromDateDefault: moment(new Date()).format("YYYY-MM-DD"),//"2024-05-21"


		uid: null,
		user_u: null,
	};



	handleGetQrCodeClick = (event) => {
		console.log('handleGetQrCodeClick, orderCost: ', this.state.orderCost);
		window.localStorage.setItem("orderCost", this.state.orderCost);
		window.localStorage.setItem("orderCurrency", this.state.orderCurrency);

		/*
         // for pay test    v
		this.setState({
            orderStatus: "PAY",
		});
        // start checking of g cvn gvb  vbjnot payment
        timerIdCheckPayment = setInterval(this.checkPayment,p[;lk timeInterval);
        console.log('89п, timerIdCheckPayment: ', timerIdCheckPayment);
        // for pay test    ^ */
        // or
        /*// for pay finish test    v
        this.setState({Профиль владельца
            orderStatus: "FINISH"
        });
        // for pay finish test    ^ */
        // or
        // for run
        this.getQrCode(this.state.productName,
            this.state.manager.firstname + " " + this.state.manager.middlename+ " " + this.state.manager.lastname,
            this.state.manager.email,
            this.state.orderCost, this.state.orderCurrency);
	};

	handleClearAllClick = () => {
		this.setState({
			orderCost: 1000,
			orderCurrency: 'RUBLE'
		}, () => {
			 console.log("handleClearAllClick: ", this.state.orderCost);
		});
		window.localStorage.removeItem("orderCost");
		window.localStorage.removeItem("orderCurrency");
        window.localStorage.removeItem("orderStatus");

		window.localStorage.removeItem("QR_DATA");
		window.localStorage.removeItem("QR_ID");
		window.localStorage.removeItem("QR_PSB_ID");
		window.localStorage.removeItem("QR_PSB_URL");
		window.localStorage.removeItem("QR_IMG_REF");
    };

    handleResetClick = () => {
        this.setState({
            orderCost: 1000,
            orderCurrency: 'RUBLE',
            orderStatus: "PURCHASE",
        }, () => {
            console.log("handleClearAllClick, state: ", this.state);
        });
        window.localStorage.removeItem("orderCost");
        window.localStorage.removeItem("orderCurrency");
        window.localStorage.removeItem("orderStatus");

		window.localStorage.removeItem("QR_DATA");
		window.localStorage.removeItem("QR_ID");
		window.localStorage.removeItem("QR_PSB_ID");
		window.localStorage.removeItem("QR_PSB_URL");
		window.localStorage.removeItem("QR_IMG_REF");

        if (timerIdCheckPayment) {
            clearInterval(timerIdCheckPayment);
            timerIdCheckPayment = null;
        }
        console.log('handleResetClick, Time interval is stopped, timerIdCheckPayment: ', timerIdCheckPayment);
        //window.location.reload();
    };

    getQrCode = async (productName = null, userName = null, userEmail = null, summa = null, currency = null) => {
        await apiStore.getQrCodePay(productName, userName, userEmail, summa, currency).then(data => {
            console.log("getQrCode, data: ", data);
            /*
            {"QR_ID": "BD1000673592A9GP9GEQ7SO0QU4VJESK",
    		 "QR_DATA": "https://qr.nspk.ru/BD1000673592A9GP9GEQ7SO0QU4VJESK?type=02&bank=100000000010&sum=100000&cur=RUB&crc=8CF7",
    		 "QR_IMG_REF": "/SBP/BD1000673592A9GP9GEQ7SO0QU4VJESK.png",
    		 "QR_PSB_ID": "235278354",
    		 "P_SIGN": "436e59da6ae701b0c0219141cd10b29aa6ac0a16458979f08963dec4e4fedf0f",
    		 "QR_IMG_DATA": "3OG8S5jTF5i1PsfMs/Ze7zWxnuRnMvLD2f/dQUzC",
    		 "QR_PSB_URL": "https://test.3ds.payment.ru"}
            */
            if (data) {
                if (data["QR_DATA"]) {
                    this.setState({ QR_DATA: data["QR_DATA"] });
                    window.localStorage.setItem("QR_DATA", data["QR_DATA"]);
                }
                if (data["QR_ID"]) {
                    this.setState({ QR_ID: data["QR_ID"] });
                    window.localStorage.setItem("QR_ID", data["QR_ID"]);
                }
                if (data["QR_PSB_ID"]) {
                    this.setState({ QR_PSB_ID: data["QR_PSB_ID"] });
                    window.localStorage.setItem("QR_PSB_ID", data["QR_PSB_ID"]);
                }
                if (data["QR_PSB_URL"]) {
                    this.setState({ QR_PSB_URL: data["QR_PSB_URL"] });
                    window.localStorage.setItem("QR_PSB_URL", data["QR_PSB_URL"]);
                }
                if (data["QR_IMG_REF"]) {
                    this.setState({
                        imageURL_QR_ID: data["QR_PSB_URL"] + data["QR_IMG_REF"],
                        orderStatus: "PAY" });
                    window.localStorage.setItem("orderStatus", "PAY");// got qr-code
                    window.localStorage.setItem("QR_IMG_REF", data["QR_IMG_REF"]);

                    // start checking of got payment
                    timerIdCheckPayment = setInterval(this.checkPayment, timeInterval);
                }

            }
        });
    };


	checkPayment = () => {
        console.log("checkPayment, timerIdCheckPayment: ", timerIdCheckPayment);
        if (this.state.QR_ID) {
              apiStore.checkQrCodePay(this.state.QR_ID).then(data => {
                console.log("checkPayment, data: ", data);
                if (data && data["result"] === 0) {
                    this.setState({ orderStatus: "FINISH" });
                    if (timerIdCheckPayment) {
                        clearInterval(timerIdCheckPayment);
                        timerIdCheckPayment = null;
                    }
                    console.log('CheckPayment, Time interval is stopped by reset.');
                    window.localStorage.removeItem("orderCost");
                    window.localStorage.removeItem("orderCurrency");
                    window.localStorage.removeItem("orderStatus");
                    window.localStorage.removeItem("QR_DATA");
                    window.localStorage.removeItem("QR_ID");
                    window.localStorage.removeItem("QR_PSB_ID");
                    window.localStorage.removeItem("QR_PSB_URL");
                    window.localStorage.removeItem("QR_IMG_REF");
                }
            });
        }
	};

	componentDidMount() {
        const userInfo = userStore.getUserInfo();
        this.setState({manager: userInfo['manager']});

	    const orderStatus = window.localStorage.getItem("orderStatus") != null
            ? window.localStorage.getItem("orderStatus") : this.state.orderStatus;

		const orderCost = window.localStorage.getItem("orderCost") != null
			? window.localStorage.getItem("orderCost") : this.state.orderCost;

		const orderCurrency = window.localStorage.getItem("orderCurrency") != null
			? window.localStorage.getItem("orderCurrency") : this.state.orderCurrency;

	    this.setState({
				orderCost: orderCost,
				orderCurrency: orderCurrency,
            	orderStatus: orderStatus,
				QR_ID: window.localStorage.getItem("QR_ID"),
				QR_PSB_ID: window.localStorage.getItem("QR_PSB_ID"),
				QR_PSB_URL: window.localStorage.getItem("QR_PSB_URL"),
				QR_IMG_REF: window.localStorage.getItem("QR_IMG_REF"),
				imageURL_QR_ID: window.localStorage.getItem("QR_PSB_URL") + window.localStorage.getItem("QR_IMG_REF")
	    });
		if (orderStatus === "PAY") { // wait payment
            timerIdCheckPayment = setInterval(this.checkPayment, timeInterval);
            console.log('componentDidMount, timerIdCheckPayment - RUN ');
        } else {
            if (timerIdCheckPayment) {
                clearInterval(timerIdCheckPayment);
                timerIdCheckPayment = null;
            }
        }
        console.log('componentDidMount, timerIdCheckPayment: ', timerIdCheckPayment);
		console.log("componentDidMount, state: ", this.state);
	}


	render() {
		//this.state.rows.slice(0, this.state.pageSize)
		const {classes} = this.props;

		return (
			<>

				<h2 style={{marginTop: 0, marginBottom: 20, marginLeft: 20}}>
					<Trans i18nKey={"Replenish"} >{"Replenish"}</Trans>
				</h2>


				<Grid container spacing={1} >
					{ this.state.orderStatus === "PURCHASE" ? (
						<Grid item xs={12} sm={12} md={12} lg={12} >
							<div style={{marginTop: 0, marginLeft: 20, marginBottom: 10}}>
								<Trans i18nKey={"PayText"} >PayText</Trans>
							</div>
							<div style={{marginTop: 0, marginLeft: 20, marginBottom: 24}}>
								<Trans i18nKey={"PayText2"} >PayText2</Trans>
							</div>
							<div style={{marginTop: 0, marginLeft: 20}}>
                                <TextField
                                    key={"select_currency"}
                                    disabled
                                    select
                                    variant={"standard"}
                                    size = "small"
                                    style={{marginLeft: 0, width: 60}}
                                    className={"underlineselect"}
                                    label={<Trans i18nKey={"Currency"} >{"Currency"}</Trans>}
                                    value={this.state.orderCurrency ? this.state.orderCurrency : ""}
                                    onChange={
                                        (event)	=> {
                                            const currency_name = event.target.value === "" ? null : event.target.value;
                                            const amount = currency_name === "RUBLE"
                                                ? (this.state.orderCost < 500 ? 500 : this.state.orderCost)
                                                : (this.state.orderCost < 10 ? 10 : this.state.orderCost);
                                            this.setState({orderCurrency: currency_name, orderCost: amount})
                                        }
                                    }
                                >
                                    {/*<MenuItem value="" key="DoesNotMatter" >
                                        <Trans i18nKey={"DoesNotMatter"}>{"DoesNotMatter"}</Trans>
                                    </MenuItem> */}
                                    <MenuItem value={"RUBLE"} key="RUBLE" >
                                        <CurrencyRubleIcon fontSize="small" style={{marginBottom: -5}} />
                                    </MenuItem>
                                    <MenuItem value={"EURO"} key="EURO" >
                                        <CurrencyEuroIcon fontSize="small" style={{marginBottom: -5}} />
                                    </MenuItem>
                                    <MenuItem value={"DOLLAR"} key="DOLLAR" >
                                        <CurrencyDollarsIcon fontSize="small" style={{marginBottom: -5}} />
                                    </MenuItem>
                                </TextField>
								<TextField
									required
									onChange={(event) => {
									    const amount = this.state.orderCurrency === "RUBLE"
                                                ? (event.target.value < 500 ? 500 : event.target.value)
                                                : (event.target.value < 10 ? 10 : event.target.value);

									    this.setState({orderCost: amount})
									}}
									value={this.state.orderCost}
									style={{marginTop: 0, marginLeft: 15, marginBottom: 24, width: 120}}
									variant="standard"
									id = "orderCost"
									name = "orderCost"
									label={<Trans i18nKey={"Summa"} >{"Summa"}</Trans>}
									type = "number"
									size = "small"
									min = "100"
									step = "10"
									InputProps={
                                        this.state.orderCurrency === "RUBLE" ?
                                            {endAdornment: <InputAdornment position="end"><CurrencyRubleIcon fontSize="small"/></InputAdornment>,}
                                        : this.state.orderCurrency === "EURO" ?
                                            {endAdornment: <InputAdornment position="end"><CurrencyEuroIcon fontSize="small"/></InputAdornment>,}
                                          : {endAdornment: <InputAdornment position="end"><CurrencyDollarsIcon fontSize="small"/></InputAdornment>,}
                                    }
								/>
								<Button
									variant="contained"
									onClick={this.handleGetQrCodeClick}
									style={{marginTop: 0, marginLeft: 20, marginBottom: 24, width: 120}}
									color="primary"
									size="large" >
									<Trans i18nKey={"Pay"} >Pay</Trans>
								</Button>
								<Button
									variant="contained"
									onClick={this.handleClearAllClick}
									style={{marginTop: 0, marginLeft: 10, marginBottom: 24, width: 120}}
									color="primary"
									size="large" >
									<Trans i18nKey={"Reset"} >Reset</Trans>
								</Button>
							</div>
						</Grid>
					) : this.state.orderStatus === "PAY" ? ( // show qr-code
						<Grid item xs={12} sm={12} md={12} lg={12}   >
							<div style={{marginTop: 0, marginLeft: 20, marginBottom: 24}}>
								<Trans i18nKey={"PayText3"} >PayText3</Trans>
                                {this.state.orderCost}
                                {this.state.orderCurrency === "RUBLE" ?
                                    (<CurrencyRubleIcon fontSize="small" style={{marginBottom: -5}} />)
                                    : this.state.orderCurrency === "EURO" ?
                                    (<CurrencyEuroIcon fontSize="small" style={{marginBottom: -5}} />)
                                    : (<CurrencyDollarsIcon fontSize="small" style={{marginBottom: -5}} />)
                                }
							</div>
                            <Grid container spacing={2} >
                                <Grid item xs={12} md={4} lg={4}style={{textAlign:'left', paddingLeft: 30}}>
                                    <img src={this.state.imageURL_QR_ID}  alt="Error of dynamically loaded..." />
                                </Grid>
                                <Grid item xs={12} md={8} lg={8} >
                                    <h2><Trans i18nKey={"PaymentProcedure"} >PaymentProcedure</Trans>:</h2>
                                    <br/>
                                    <p>
                                        <li> <Trans i18nKey={"PaymentProcedure1"} >PaymentProcedure1</Trans></li>
                                        <li> <Trans i18nKey={"PaymentProcedure2"} >PaymentProcedure2</Trans></li>
                                        <li> <Trans i18nKey={"PaymentProcedure3"} >PaymentProcedure3</Trans></li>
                                        <li> <Trans i18nKey={"PaymentProcedure4"} >PaymentProcedure4</Trans></li>
                                        <li> <Trans i18nKey={"PaymentProcedure5"} >PaymentProcedure5</Trans></li>
                                    </p>
                                    <div style={{marginTop: 10, marginLeft: 5}}>
                                        <Button
                                            variant="contained"
                                            onClick={this.handleResetClick}
                                            style={{marginTop: 0, marginLeft: 10, marginBottom: 24, width: 120}}
                                            color="primary"
                                            size="large" >
                                            <Trans i18nKey={"Reset"} >Reset</Trans>
                                        </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </Grid>
					) : this.state.orderStatus === "FINISH" ? ( // show window with finished payment
                        <Grid item xs={12} sm={12} md={12} lg={12} >
                            <div style={{marginTop: 0, marginLeft: 90, marginBottom: 10}}>
                                <DoneOutlineIcon color="primary"/>
                            </div>
                            <h3 style={{marginTop: 0, marginLeft: 20, marginBottom: 10}}>
                                <Trans i18nKey={"PayText4"} >PayText4</Trans>
                            </h3>
                            <h3 style={{marginTop: 0, marginLeft: 20, marginBottom: 10}}>
                                <Trans i18nKey={"BalanceUpto"} >BalanceUpto</Trans>
                                {": " + this.state.orderCost  + " "}
                                {this.state.orderCurrency === "RUBLE" ? (<CurrencyRubleIcon fontSize="small" style={{marginBottom: -5}} />)
                                    : this.state.orderCurrency === "EURO" ? (<CurrencyEuroIcon fontSize="small" style={{marginBottom: -5}} />)
                                    : (<CurrencyDollarsIcon fontSize="small" style={{marginBottom: -5}} />)
                                }
                            </h3>
                        </Grid>
                    ) : this.state.orderStatus}
				</Grid>

				<ThemeProvider
					theme={theme}
				>
					<div className={classes.root} >
					</div>
				</ThemeProvider>
			</>
		);
	}
}


const mapStateToProps = state => {
	return state;
};

const mapDispatchToProps = {

};

export default withStyles(useStyles)(connect(mapStateToProps, mapDispatchToProps)(TopUpBalance));
